import React from 'react';
import { Image, type ImageStyle, type StyleProp } from 'react-native';

const appIcon = require('../../assets/branding/app-icon-96.webp');

type BrandMarkProps = {
  size?: number;
  style?: StyleProp<ImageStyle>;
};

/** Display-sized web mark (96px WebP) — native BrandMark keeps the 256 PNG. */
export function BrandMark({ size = 28, style }: BrandMarkProps) {
  return (
    <Image
      source={appIcon}
      resizeMode="cover"
      accessibilityIgnoresInvertColors
      style={[{ width: size, height: size, borderRadius: Math.round(size * 0.22) }, style]}
    />
  );
}
